<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Combo',
  data() {
    return {}
  }
}
</script>
<style lang="" scoped></style>
